import { useStoreMap } from 'effector-react';
import { $auth } from './store';

export const useUserSelector = () => useStoreMap($auth, ({ user }) => user);
export const useAuthSelector = () => useStoreMap($auth, ({ isAuth }) => isAuth);
